import { FETCH_EVENT_SYNCS, FETCH_EVENT_REPORT, CLEAR_EVENT_SYNCS } from '../actions/actionTypes';

const preState = {
	syncs: [],
	report: {},
};

const eventSyncsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, eventSyncs, report } = action;

	switch (type) {
		case FETCH_EVENT_SYNCS:
			return { ...stateDup, syncs: eventSyncs.nodes };
		case FETCH_EVENT_REPORT:
			return { ...stateDup, report };
		case CLEAR_EVENT_SYNCS:
			return { syncs: [], report: {} };
		default:
			return stateDup;
	}
};

export default eventSyncsReducer;
